import React from 'react';
export function Footer() {
  return <footer className="bg-navy-dark pt-20 pb-8 px-6 relative overflow-hidden" data-id="element-246">
      {/* Gradient Top Border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-teal/30 to-transparent" data-id="element-247" />

      {/* Subtle Ambient Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-purple/5 rounded-full blur-[100px] pointer-events-none" data-id="element-248" />

      <div className="inner-container relative z-10" data-id="element-249">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-250">
          {/* Col 1 */}
          <div data-id="element-251">
            <a href="/" className="flex items-center gap-2 mb-4" data-id="element-252">
              <img src="https://cdn.magicpatterns.com/uploads/dWXrt9xNFh6bNpGwsjysP6/ChatGPT_Image_Mar_20,_2026,_02_15_39_PM.png" alt="MINDStream.ing icon" className="h-9 w-9 rounded-lg" data-id="element-253" />
              <span className="font-poppins text-2xl font-extrabold tracking-tight" data-id="element-254">
                <span style={{
                color: '#3D32AE'
              }} data-id="element-255">
                  MIND
                </span>
                <span className="text-teal font-medium" data-id="element-256">stream</span>
                <span style={{
                color: '#3D32AE'
              }} className="italic font-bold" data-id="element-257">
                  .ing
                </span>
              </span>
            </a>
            <p className="font-poppins font-semibold text-white/90 mb-4" data-id="element-258">
              Your Business. Running Itself.
            </p>
            <p className="text-sm text-steel leading-relaxed" data-id="element-259">
              MR is your AI chief of operations. It manages your projects, runs
              your team, coordinates clients, and executes across your entire
              business — 24/7.
            </p>
          </div>

          {/* Col 2 */}
          <div data-id="element-260">
            <h4 className="font-poppins font-semibold text-white mb-6" data-id="element-261">
              Product
            </h4>
            <ul className="space-y-3 text-sm text-steel" data-id="element-262">
              <li data-id="element-263">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-264">
                  Features
                </a>
              </li>
              <li data-id="element-265">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-266">
                  Pricing
                </a>
              </li>
              <li data-id="element-267">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-268">
                  Integrations
                </a>
              </li>
              <li data-id="element-269">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-270">
                  How It Works
                </a>
              </li>
              <li data-id="element-271">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-272">
                  ThinkTank
                </a>
              </li>
            </ul>
          </div>

          {/* Col 3 */}
          <div data-id="element-273">
            <h4 className="font-poppins font-semibold text-white mb-6" data-id="element-274">
              Company
            </h4>
            <ul className="space-y-3 text-sm text-steel" data-id="element-275">
              <li data-id="element-276">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-277">
                  About
                </a>
              </li>
              <li data-id="element-278">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-279">
                  Partners
                </a>
              </li>
              <li data-id="element-280">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-281">
                  Community
                </a>
              </li>
              <li data-id="element-282">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-283">
                  Blog
                </a>
              </li>
              <li data-id="element-284">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-285">
                  Contact
                </a>
              </li>
              <li data-id="element-286">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-287">
                  Security
                </a>
              </li>
            </ul>
          </div>

          {/* Col 4 */}
          <div data-id="element-288">
            <h4 className="font-poppins font-semibold text-white mb-6" data-id="element-289">
              Resources
            </h4>
            <ul className="space-y-3 text-sm text-steel" data-id="element-290">
              <li data-id="element-291">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-292">
                  Case Studies
                </a>
              </li>
              <li data-id="element-293">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-294">
                  VS Competitors
                </a>
              </li>
              <li data-id="element-295">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-296">
                  Enterprise
                </a>
              </li>
              <li data-id="element-297">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-298">
                  Documentation
                </a>
              </li>
              <li data-id="element-299">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-300">
                  Affiliate Program
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 relative flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-steel" data-id="element-301">
          {/* Gradient Divider */}
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" data-id="element-302" />

          <p data-id="element-303">© 2026 MINDstream.ing — Ad ROI, LLC. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-304">
            <a href="#" className="hover:text-white transition-colors" data-id="element-305">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-306">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}